import { checkErrorMessage } from '@shared/error/lib/chekErrorMassage';

export const END_TO_END_CHECKIN_ERROR_MESSAGE =
	'It is not possible to check-in for only one segment during end-to-end check-in.';

/** WEBSKY-8351: Ошибка сквозной реигстрации на чекине */
export const isEndToEndCheckinError = (error: unknown): boolean => {
	return checkErrorMessage(error, END_TO_END_CHECKIN_ERROR_MESSAGE);
};
